import Crear from "./Crear";
import Editar from "./Editar";
import Listado from "./Listado";
import Ver from "./Ver";

const paginas = { Crear, Editar, Listado, Ver };
export default paginas